export const UPDATE_PROPERTY = 'UPDATE_PROPERTY'

export const updateProperty = (productId, properties = {}) => ({
  type: UPDATE_PROPERTY,
  productId,
  properties
})
